import { MutationOptions } from '@tanstack/react-query';
import { useApiMutation } from '~/hooks';
import {
  deleteExtractionDataApi,
  deleteAccountApi,
  DeleteExtractionDataResponse,
  DeleteAccountResponse,
} from '../repository';

/**
 * Mutation hook for deleting all extraction data
 * @param options - Additional mutation options
 * @returns React Query mutation result
 */
export const useDeleteExtractionDataMutation = (
  options?: MutationOptions<
    DeleteExtractionDataResponse,
    CustomAxiosError,
    boolean
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (confirm: boolean) => deleteExtractionDataApi(confirm),
  });
};

/**
 * Mutation hook for deleting user account
 * @param options - Additional mutation options
 * @returns React Query mutation result
 */
export const useDeleteAccountMutation = (
  options?: MutationOptions<
    DeleteAccountResponse,
    CustomAxiosError,
    { password: string; confirm: boolean }
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (data: { password: string; confirm: boolean }) =>
      deleteAccountApi(data.password, data.confirm),
  });
};
